// UMIKARA Theme Global JavaScript

class UmikaraTheme {
  constructor() {
    this.init();
  }

  init() {
    this.setupMobileMenu();
    this.setupSmoothScroll();
    this.setupLazyLoading();
  }

  setupMobileMenu() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        mobileMenu.classList.toggle('is-open');
        document.body.classList.toggle('menu-open');
      });
    }
  }

  setupSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  setupLazyLoading() {
    if ('IntersectionObserver' in window) {
      const lazyImages = document.querySelectorAll('img[loading="lazy"]');
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      });

      lazyImages.forEach(img => imageObserver.observe(img));
    }
  }
}

// Cart functionality
class UmikaraCart {
  constructor() {
    this.cartUrl = window.routes ? window.routes.cart_url : '/cart';
    this.init();
  }

  init() {
    this.setupAddToCartForms();
  }

  setupAddToCartForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', this.handleAddToCart.bind(this));
    });
  }

  async handleAddToCart(event) {
    event.preventDefault();
    const form = event.target;
    const submitButton = form.querySelector('[type="submit"]');
    
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    }

    try {
      const formData = new FormData(form);
      const addUrl = `${window.routes.cart_add_url}.js`.replace('/cart/add.js.js', '/cart/add.js');
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (response.ok) {
        // cart/add.js returns the added line item, not the full cart state.
        // Fetch the current cart so the header badge can be updated immediately.
        await response.json();
        const cartUrl = `${window.routes.cart_url}.js`.replace('/cart.js.js', '/cart.js');
        const cartResponse = await fetch(cartUrl, {
          headers: { 'Accept': 'application/json' }
        });
        if (!cartResponse.ok) throw new Error('Failed to refresh cart');
        const cart = await cartResponse.json();
        this.updateCartCount(cart.item_count);
        this.showNotification('カートに追加しました');
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      this.showNotification('エラーが発生しました', 'error');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
      }
    }
  }

  updateCartCount(count) {
    // Legacy header badge (if the old header section is used anywhere)
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // Current UMIKARA header badge. When the cart is empty Liquid does not
    // render the badge, so create it on the first add-to-cart action.
    document.querySelectorAll('.umi-header-icon[aria-label="カート"]').forEach(cartLink => {
      let badge = cartLink.querySelector('.umi-cart-count');

      if (count > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'umi-cart-count';
        cartLink.appendChild(badge);
      }

      if (badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.setAttribute('aria-label', `カートに${count}点`);
          badge.style.display = '';
        } else {
          badge.remove();
        }
      }
    });
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.classList.add('is-visible');
    }, 100);

    setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.umikaraTheme = new UmikaraTheme();
  window.umikaraCart = new UmikaraCart();
});

// Quantity selector component
class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="number"]');
    this.decreaseButton = this.querySelector('[data-action="decrease"]');
    this.increaseButton = this.querySelector('[data-action="increase"]');

    if (this.decreaseButton) {
      this.decreaseButton.addEventListener('click', () => this.updateQuantity(-1));
    }
    if (this.increaseButton) {
      this.increaseButton.addEventListener('click', () => this.updateQuantity(1));
    }
  }

  updateQuantity(change) {
    const currentValue = parseInt(this.input.value) || 1;
    const newValue = Math.max(1, currentValue + change);
    this.input.value = newValue;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}
